<template lang="html">
  <v-page :profile="profile">
    <div v-if="showHolidayModal" class="holiday-modal" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 9999; display: flex; justify-content: center; align-items: center;">
      <div style="background: white; padding: 30px; border-radius: 10px; max-width: 500px; text-align: center;">

        <v-button @click="closeHolidayModal" class="mt-3">Fechar</v-button>
      </div>
    </div>
    <v-topbar :profile="profile" />
    <v-breadcrumb :steps="[{ label: 'Profissionais' }]" />

    <v-container>
      <v-tabs id="user-list-tabs" class="mb-3 nav-pills">
        <v-button
          href="#active"
          @click="clickTabButton('active')"
          :class="showTabButton('active')"
          >Ativos</v-button
        >
        <v-button
          href="#pending"
          @click="clickTabButton('pending')"
          :class="showTabButton('pending')"
          >Em contratação</v-button
        >
        <v-button
          href="#finalized"
          @click="clickTabButton('finalized')"
          :class="showTabButton('finalized')"
          >Finalizados</v-button
        >
        <v-button
          href="#credit-transfer"
          :class="showTabButton('credit-transfer')"
          >Transferência de Crédito</v-button
        >
        <v-button class="ml-auto mr-0 white" @click="searchVibbrantes"
          >Buscar novos</v-button
        >
      </v-tabs>
      <v-div class="tab-content">
        <v-content
          class="tab-pane"
          :class="showTabContent('active')"
          id="active"
          role="tabpanel"
        >
          <v-row>
            <v-col md="12">
              <v-div class="user-items">
                <v-row class="size-2">
                  <v-alert v-if="activesContracts.length === 0" close>
                    <strong
                      >Você não possui profissionais com contratos
                      ativos</strong
                    ><br />
                    Quando contratá-los, eles irão aparecer aqui para que possa
                    acompanhar o andamento dos trabalhos.<br />
                    <v-link :to="{ name: 'client-search' }"
                      >Comece explorando a nossa rede!</v-link
                    >
                  </v-alert>
                  <v-col
                    :xs="12"
                    :md="6"
                    :lg="6"
                    v-for="contract in activesContracts"
                    :key="contract.id"
                  >
                    <v-card class="mb-0 p-3 card-user">
                      <v-avatar
                        @click="openVibbranteNewTab(contract.vibbrante)"
                        :name="
                          contract.vibbrante.name +
                            ' ' +
                            contract.vibbrante.lastname
                        "
                        :about="
                          contract.vibbrante.profile +
                            '<br>' +
                            contract.vibbrante.focus
                        "
                        class="pointer"
                        :image="contract.vibbrante.avatar_old"
                      >
                      </v-avatar>
                      <div v-if="contract.last_tasks.length === 0">
                        <v-divider line class="mb-2"
                          >Nenhuma tarefa registrada</v-divider
                        >
                      </div>
                      <div v-else>
                        <v-divider line class="mb-2 mt-3"
                          >Últimas tarefas</v-divider
                        >
                        <v-list class="user-profile">
                          <v-text
                            v-for="task in contract.last_tasks"
                            :key="n"
                            tag="div"
                          >
                            {{ task.task_date | moment('DD/MM/YYYY') }} -
                            {{ task.duration }}h - {{ task.description }}
                          </v-text>
                        </v-list>
                      </div>
                      <div class="d-flex align-items-center">
                        <v-button
                          class="block primary mt-3"
                          :size="2"
                          @click="goToTasks(contract.vibbrante.name, contract.id)"
                        >
                          Acompanhamento
                        </v-button>
                      </div>
                      <small slot="top-right" class="text-muted"
                        >{{ contract.work_hours }}h trabalhadas</small
                      >
                      <small
                        slot="top-left"
                        class="badge badge-danger"
                        v-if="contract.release_hours === 0"
                        >sem créditos</small
                      >
                      <small
                        slot="top-left"
                        class="badge badge-success"
                        v-if="contract.vibbrante.vibbrante_type === 'vibbrante'"
                        >{{ contract.vibbrante.vibbrante_type }}!</small
                      >
                      <small
                        slot="top-left"
                        class="badge badge-light"
                        v-if="
                          contract.vibbrante.vibbrante_type === 'freelancer'
                        "
                        >{{ contract.vibbrante.vibbrante_type }}</small
                      >
                    </v-card>
                  </v-col>
                </v-row>
              </v-div>
            </v-col>
          </v-row>
        </v-content>
        <v-content
          class="tab-pane"
          :class="showTabContent('pending')"
          id="pending"
          role="tabpanel"
        >
          <v-row>
            <v-col md="12">
              <v-div class="user-items">
                <v-row class="size-2">
                  <v-alert v-if="pendingContracts.length === 0" close>
                    <strong>Você não possui profissionais em contratação</strong
                    ><br />
                    Aqui irão aparecer aqueles profissionais que você escolheu e
                    estão no processo de contratação.<br />
                    <v-link :to="{ name: 'client-search' }"
                      >Por hora, acesse a tela de busca e encontre os
                      profissionais certos pra você!</v-link
                    >
                  </v-alert>
                  <v-col
                    :xs="12"
                    :lg="4"
                    v-for="contract in pendingContracts"
                    :key="contract.id"
                  >
                    <v-card class="mb-0 p-3 card-user">
                      <v-avatar
                        @click="openVibbranteNewTab(contract.vibbrante)"
                        :name="contract.vibbrante.name"
                        :about="
                          contract.vibbrante.profile +
                            '<br>' +
                            contract.vibbrante.focus
                        "
                        class="pointer"
                        :image="contract.vibbrante.avatar_old"
                      >
                        <br />
                        <small
                          class="badge badge-info"
                          v-if="
                            contract.status === 'waiting_answer_from_vibbrante'
                          "
                          >{{
                            getStatusDescription(
                              contract.status,
                              contract.release_reject_message
                            )
                          }}</small
                        >
                        <small
                          class="badge badge-primary"
                          v-if="
                            contract.status ===
                              'waiting_confirmation_from_client'
                          "
                          >{{
                            getStatusDescription(
                              contract.status,
                              contract.release_reject_message
                            )
                          }}</small
                        >
                        <small
                          class="badge badge-danger"
                          v-if="
                            contract.status === 'reject_by_vibbrante' &&
                              contract.release_reject_message
                          "
                          >{{
                            getStatusDescription(
                              contract.status,
                              contract.release_reject_message
                            )
                          }}</small
                        >
                        <small
                          class="badge badge-secondary"
                          v-if="
                            contract.status === 'reject_by_vibbrante' &&
                              !contract.release_reject_message
                          "
                          >{{
                            getStatusDescription(
                              contract.status,
                              contract.release_reject_message
                            )
                          }}</small
                        >
                        <small
                          class="badge badge-warning"
                          v-if="contract.status === 'waiting_credit'"
                          >{{
                            getStatusDescription(
                              contract.status,
                              contract.release_reject_message
                            )
                          }}</small
                        >
                      </v-avatar>
                      <v-list class="user-profile mt-3">
                        <v-text tag="div"
                          >Quantidade de horas desejadas:
                          <span
                            v-if="
                              contract.contract_hours != contract.expect_hours
                            "
                          >
                            <small
                              ><s>{{ contract.expect_hours }}</s></small
                            >{{ contract.contract_hours }} h
                          </span>
                          <span v-else> {{ contract.expect_hours }} h </span>
                        </v-text>
                        <v-text tag="div"
                          >Experiência:
                          <span
                            >{{
                              contract.vibbrante.years_experience
                            }}
                            anos</span
                          >
                        </v-text>
                        <v-text tag="div" v-if="!user.hide_value_hour">
                          Valor/hora:
                          <span
                            v-if="
                              contract.status ===
                                'waiting_confirmation_from_client' ||
                                contract.status === 'waiting_credit'
                            "
                          >
                            <span
                              v-if="
                                contract.hour_value !=
                                  contract.expected_hour_value
                              "
                              :title="
                                ('desconto ' +
                                  calcDiscount(
                                    contract.hour_value,
                                    contract.expected_hour_value
                                  ))
                                  | currency
                              "
                            >
                              <small
                                ><s>{{
                                  contract.expected_hour_value | currency
                                }}</s></small
                              >
                              {{ contract.hour_value | currency }}
                            </span>
                            <span v-else>
                              {{ contract.hour_value | currency }}
                            </span>
                          </span>
                          <span v-else>{{
                            contract.expected_hour_value | currency
                          }}</span>
                        </v-text>
                        <v-text tag="div"
                          >Horas semanais:
                          <span
                            v-if="
                              contract.hour_available ===
                                contract.expected_hour_available
                            "
                          >
                            {{ contract.hour_available }} h
                          </span>
                          <span v-else>
                            <small
                              ><s
                                >{{ contract.expected_hour_available }} h</s
                              ></small
                            >
                            {{ contract.hour_available }} h
                          </span>
                        </v-text>
                        <v-text tag="div" v-if="contract.description" class="dont-break-out">
                            {{ contract.description }}
                        </v-text>
                        <v-text tag="div" v-else>
                          Nenhuma descrição informada.
                        </v-text>
                      </v-list>
                      <v-stars
                        :stars="contract.vibbrante.score"
                        slot="top-right"
                        v-if="contract.vibbrante.vibbrante_type === 'vibbrante'"
                      ></v-stars>
                      <v-row
                        :size="1"
                        v-if="
                          contract.status === 'reject_by_vibbrante' &&
                            contract.release_reject_message
                        "
                      >
                        <v-col :md="12">
                          <v-button
                            class="block link mt-2"
                            :size="2"
                            @click="
                              showJustificationModal(
                                contract,
                                contract.reject_description,
                                contract.cancellation_reason.description
                              )
                            "
                            >Ver justificativa</v-button
                          >
                        </v-col>
                      </v-row>
                      <v-row :size="1" v-else>
                        <v-col :md="6">
                          <v-button
                            class="block link mt-2"
                            :size="1"
                            @click="showQuestion(contract)"
                          >
                            Mensagens
                            <v-badge
                              class="mr-2 mb-2 danger"
                              size="2"
                              v-if="contract.comments_unread_from_vibbrante > 0"
                            >
                              <i class="icon icon-email"></i>
                            </v-badge>
                          </v-button>
                        </v-col>
                        <v-col :md="6">
                          <v-button
                            class="block link mt-2"
                            :size="1"
                            @click="showRejectModal(contract)"
                            >Cancelar</v-button
                          >
                        </v-col>
                      </v-row>
                      <v-button
                        v-if="
                          contract.status === 'waiting_confirmation_from_client'
                        "
                        class="block primary mt-2"
                        :size="2"
                        @click="goToSign(contract)"
                        >Assinar contrato</v-button
                      >
                      <v-button
                        v-else-if="
                          contract.status === 'reject_by_vibbrante' &&
                            contract.release_reject_message
                        "
                        class="block primary mt-2"
                        :size="2"
                        @click="searchWithFilter(contract.vibbrante)"
                        title="Buscar profissionais com perfil semelhante"
                        >Buscar parecidos</v-button
                      >
                      <v-button
                        v-else-if="contract.status === 'waiting_credit'"
                        class="block primary mt-2"
                        :size="2"
                        @click="openWallet"
                        >Comprar créditos</v-button
                      >
                      <v-button
                        v-else-if="
                          contract.status === 'waiting_answer_from_vibbrante' ||
                            !contract.release_reject_message
                        "
                        class="block primary mt-2"
                        :size="2"
                        @click=""
                        disabled
                        >Assinar contrato</v-button
                      >
                      <small
                        slot="top-left"
                        class="badge badge-success"
                        v-if="contract.vibbrante.vibbrante_type === 'vibbrante'"
                        >{{ contract.vibbrante.vibbrante_type }}!</small
                      >
                      <small
                        slot="top-left"
                        class="badge badge-light"
                        v-if="
                          contract.vibbrante.vibbrante_type === 'freelancer'
                        "
                        >{{ contract.vibbrante.vibbrante_type }}</small
                      >
                    </v-card>
                  </v-col>
                </v-row>
              </v-div>
            </v-col>
          </v-row>
        </v-content>
        <v-content
          class="tab-pane "
          :class="showTabContent('finalized')"
          id="finalized"
          role="tabpanel"
        >
          <v-row>
            <v-col md="12">
              <v-div class="user-items">
                <v-row class="size-2">
                  <v-alert v-if="closedContracts.length === 0" close>
                    <strong
                      >Você não possui profissionais com contratos
                      finalizados</strong
                    ><br />
                    Aqui você poderá consultar sempre o histórico de como foi o
                    trabalho com cada um dos profissionais contratados.<br />
                    <v-link :to="{ name: 'client-search' }"
                      >Acesse a tela de busca para encontrar nossos
                      profissionais!</v-link
                    >
                  </v-alert>
                  <v-col
                    :xs="12"
                    :md="6"
                    :lg="4"
                    v-for="contract in closedContracts"
                    :key="contract.id"
                  >
                    <v-card class="mb-0 p-3 card-user">
                      <v-avatar
                        @click="openVibbranteNewTab(contract.vibbrante)"
                        :name="
                          contract.vibbrante.name +
                            ' ' +
                            contract.vibbrante.lastname
                        "
                        :about="
                          contract.vibbrante.profile +
                            '<br>' +
                            contract.vibbrante.focus
                        "
                        class="pointer"
                        :image="contract.vibbrante.avatar_old"
                      >
                      </v-avatar>
                      <v-divider line class="mb-2">
                        Finalizado em
                        {{ contract.close_date | moment('DD/MM/YYYY') }}
                      </v-divider>
                      <v-button
                        v-if="!contract.rating"
                        class="block primary mt-4"
                        @click="showRatingModal(contract)"
                        :size="2"
                        >Avaliar</v-button
                      >
                      <div v-else class="text-center mb-2">
                        <v-col :xs="12" :md="12" :lg="12" class="text-header">
                          {{
                            getClientType() === 'client'
                              ? 'Como avaliei este profissional?'
                              : 'Como este cliente me avaliou?'
                          }}
                        </v-col>
                        <v-row class="size-1">
                          <v-col :xs="12" :md="6" :lg="6" class="text-right">
                            Qualidade
                          </v-col>
                          <v-col :xs="12" :md="6" :lg="6">
                            <v-stars
                              class="mt-1"
                              mode="full"
                              :stars="contract.rating_quality"
                            />
                          </v-col>
                        </v-row>
                        <v-row class="size-1">
                          <v-col :xs="12" :md="6" :lg="6" class="text-right">
                            Profissionalismo
                          </v-col>
                          <v-col :xs="12" :md="6" :lg="6">
                            <v-stars
                              class="mt-1"
                              mode="full"
                              :stars="contract.rating_professionalism"
                            />
                          </v-col>
                        </v-row>
                        <v-row class="size-1">
                          <v-col :xs="12" :md="6" :lg="6" class="text-right">
                            Contrataria de novo
                          </v-col>
                          <v-col :xs="12" :md="6" :lg="6">
                            <v-stars
                              class="mt-1"
                              mode="full"
                              :stars="contract.rating_recommendation"
                            />
                          </v-col>
                        </v-row>
                        <div v-if="contract.rating_client">
                          <v-col :xs="12" :md="12" :lg="12" class="text-header">
                            {{
                              getClientType() === 'client'
                                ? 'Como este profissional me avaliou?'
                                : 'Como avaliei este cliente?'
                            }}
                          </v-col>
                          <v-row class="size-1">
                            <v-col :xs="12" :md="6" :lg="6" class="text-right">
                              Gestão
                            </v-col>
                            <v-col :xs="12" :md="6" :lg="6">
                              <v-stars
                                class="mt-1"
                                mode="full"
                                :stars="contract.rating_management"
                              />
                            </v-col>
                          </v-row>
                          <v-row class="size-1">
                            <v-col :xs="12" :md="6" :lg="6" class="text-right">
                              Disponibilidade
                            </v-col>
                            <v-col :xs="12" :md="6" :lg="6">
                              <v-stars
                                class="mt-1"
                                mode="full"
                                :stars="contract.rating_availability"
                              />
                            </v-col>
                          </v-row>
                          <v-row class="size-1">
                            <v-col :xs="12" :md="6" :lg="6" class="text-right">
                              Trabalharia de novo
                            </v-col>
                            <v-col :xs="12" :md="6" :lg="6">
                              <v-stars
                                class="mt-1"
                                mode="full"
                                :stars="contract.rating_interest_new_job"
                              />
                            </v-col>
                          </v-row>
                        </div>
                      </div>
                      <v-button
                        class="block gray mt-2"
                        :size="2"
                        @click="goToTasks(contract.vibbrante.name, contract.id)"
                        >Ver histórico</v-button
                      >
                      <small slot="top-right" class="text-muted"
                        >{{ contract.work_hours }}h trabalhadas</small
                      >
                      <small
                        slot="top-left"
                        class="badge badge-success"
                        v-if="contract.vibbrante.vibbrante_type === 'vibbrante'"
                        >{{ contract.vibbrante.vibbrante_type }}!</small
                      >
                      <small
                        slot="top-left"
                        class="badge badge-light"
                        v-if="
                          contract.vibbrante.vibbrante_type === 'freelancer'
                        "
                        >{{ contract.vibbrante.vibbrante_type }}</small
                      >
                    </v-card>
                  </v-col>
                </v-row>
              </v-div>
            </v-col>
          </v-row>
          <pagination
            :totalPages="closedContractsPaginate.totalPages"
            :loadPage="loadClosedContracts"
          ></pagination>
        </v-content>
        <v-content
          class="tab-pane"
          :class="showTabContent('credit-transfer')"
          id="credit-transfer"
          role="tabpanel"
        >
          <v-row>
            <v-col md="12">
              <v-div class="user-items">
                <v-row class="size-2">
                  <v-col :xs="12">
                    <v-input
                      type="select"
                      :options="activesContractsIds"
                      :disabled="activesContractsIds.length === 0"
                      v-model="credit_transfer.contract_from_id"
                      @change="setContractFrom"
                      >Contrato de saída dos créditos</v-input
                    >
                  </v-col>
                  <template v-if="!user.hide_value_hour">
                    <v-col :xs="12" :md="4" :lg="4">
                      <v-input type="money" disabled v-model="value_contract_from"
                        >Valor hora do contrato de origem</v-input
                      >
                    </v-col>
                    <v-col :xs="12" :md="4" :lg="4">
                      <v-input
                        type="text"
                        disabled
                        v-model="hour_debit_contract_from"
                        >Horas debitadas no contrato de origem</v-input
                      >
                    </v-col>
                    <v-col :xs="12" :md="4" :lg="4">
                      <v-input
                        type="money"
                        disabled
                        v-model="credit_transfer.value_available"
                        >Valor disponível</v-input
                      >
                    </v-col>
                  </template>

                  <v-col :xs="12">
                    <v-input
                      type="select"
                      :options="pendingContractsIds"
                      :disabled="
                        pendingContractsIds.length === 0 ||
                          !credit_transfer.contract_from_id
                      "
                      v-model="credit_transfer.contract_to_id"
                      @change="setContractTo"
                      >Contrato que recebe os créditos</v-input
                    >
                  </v-col>
                  <v-col
                    v-if="!user.hide_value_hour"
                    :xs="12"
                    :md="4"
                    :lg="4"
                    style="margin-bottom: 0px!important; padding-bottom: 0px!important;"
                  >
                    <v-input type="money" disabled v-model="value_contract_to"
                      >Valor hora do contrato de destino</v-input
                    >
                  </v-col>
                  <v-col
                    :xs="12"
                    :md="4"
                    :lg="4"
                    style="margin-bottom: 0px!important; padding-bottom: 0px!important;"
                  >
                    <v-input
                      class="m-0"
                      type="range"
                      v-model="hour_credit_contract_to"
                      :min="0"
                      :max="max_hour_credit_contract_to"
                      tooltip="hover"
                      :interval="1"
                      expandSlider="true"
                      @change="changeValueTransfer"
                    >
                      Horas creditadas no contrato de destino:
                      <small>{{ hour_credit_contract_to }}:00</small>
                    </v-input>
                  </v-col>
                  <v-col
                    v-if="!user.hide_value_hour"
                    :xs="12"
                    :md="4"
                    :lg="4"
                    style="margin-bottom: 0px!important; padding-bottom: 0px!important;"
                  >
                    <v-input
                      type="money"
                      disabled
                      v-model="credit_transfer.value_transfer"
                      >Valor a ser transferido</v-input
                    >
                  </v-col>

                  <v-col
                    :xs="12"
                    :md="12"
                    :lg="12"
                    style="margin-top: 0px!important; padding-top: 0px!important;"
                  >
                    <small
                      >O sistema só permite a transferência de horas cheias no
                      contrato de destino, não podendo quebrar o total de
                      horas.</small
                    >
                  </v-col>

                  <v-col :xs="12" :md="12" :lg="12">
                    <v-input
                      type="textarea"
                      rows="5"
                      v-model="credit_transfer.description"
                      >Observação</v-input
                    >
                  </v-col>

                  <v-col :xs="12" :md="12" :lg="12">
                    <v-alert close>
                      <strong>Solicitação de transferência de créditos</strong
                      ><br />
                      Esta solicitação será validada e aprovada pela equipe de
                      Customer Success da Vibbra
                    </v-alert>
                  </v-col>

                  <v-col :xs="12" :md="12" :lg="12">
                    <v-button
                      class="primary"
                      :disabled="disableButtonCreditTransfer()"
                      @click="createCreditTransfer()"
                      >Enviar Solicitação</v-button
                    >
                  </v-col>
                </v-row>
              </v-div>
            </v-col>
          </v-row>
        </v-content>
      </v-div>
    </v-container>

    <!-- MODALS -->
    <v-modals
      name="description-text"
      :show="descriptionModalShow"
      :data="{ descriptionText: currentDescriptionText }"
      @onHide="descriptionModalShow = false"
    />
    <v-modals
      name="recesso-2022"
      :show="recesso_2022"
      :data="{ vibbrante: true }"
      @onHide="recesso_2022 = false"
    />
    <v-modals
      name="user"
      :show="user_modal_show"
      :data="{ user: selected_vibbrante }"
      @onHide="user_modal_show = false"
    />
    <v-modals
      name="user-justification"
      title="Justificativa"
      :show="user_justification_modal_show"
      :data="{
        text: justification_text,
        contract: selected_contract,
        cancellation_reason: cancellation_reason,
      }"
      @onHide="user_justification_modal_show = false"
      profile="client"
    />
    <v-modals
      name="user-question"
      title="Tire suas dúvidas com o Vibbrante"
      :show="user_question_modal_show"
      :data="{
        comments: comments,
        contract_id: selected_contract.id,
        comment_from: 'client',
      }"
      @onHide="user_question_modal_show = false"
    />
    <v-cancel-contract
      name="client-cancel-contract"
      :title="rejectModalTitle"
      :show="client_cancel_contract_modal_show"
      :data="{ contract: selected_contract }"
      @onHide="client_cancel_contract_modal_show = false"
    />
    <v-modals
      name="contract-finalize-vibbrant"
      :show="contract_finalize_modal_show"
      :data="{ contract: selected_contract, vibbrante_name: vibbrante_name }"
      @onHide="contract_finalize_modal_show = false"
    />
    <v-modals
      name="finalized"
      :show="finalized_modal_show"
      @onHide="finalized_modal_show = false"
      :data="{}"
    />
    <v-modals
      name="alert"
      :show="alert_modal_show"
      @onHide="alert_modal_show = false"
      :data="{ message: alert_msg, destiny: 'client-profile' }"
    />
    <RatingNpsCsatVibbra />
    <v-announcement-modal
      v-if="showAnnouncementModal"
      :show="showAnnouncementModal"
      ref="announcementModal"
      @onHide="hideAnnouncementModal"
    />
    <v-modals
      name="export-modal"
      :title="'Exportar Horas'"
      :show="showingExportModal"
      @close="closeExportModal"
    >
      <div class="p-3">
        <v-row>
          <v-col :md="6">
            <v-input
              type="date"
              label="Data Início"
              v-model="exportDateRange.start"
            />
          </v-col>
          <v-col :md="6">
            <v-input
              type="date"
              label="Data Fim"
              v-model="exportDateRange.end"
            />
          </v-col>
        </v-row>
        <v-button
          class="primary mt-3"
          :disabled="!exportDateRange.start || !exportDateRange.end"
          @click="exportToExcel"
        >
          Exportar
        </v-button>
      </div>
    </v-modals>
  </v-page>
</template>

<script>
import clientApi from '@/api/client';
import RatingNpsCsatVibbra from '@/parts/components/rating-nps-csat-vibbra';
import * as XLSX from 'xlsx';
import CancelContractModal from '@/parts/modals/client-cancel-contract';
import Pagination from '@/parts/components/pagination';

export default {
  props: {
    profile: String,
    activeTab: {
      type: String,
      default: 'active',
    },
  },
  components: {
    'v-cancel-contract': CancelContractModal,
    pagination: Pagination,
    RatingNpsCsatVibbra,
  },
  created() {
    this.fetchData();
  },
  mounted() {
    this.showRecessoCampaing();
    const fullPath = this.$route.fullPath;
    const currentTab = fullPath.split('/')[fullPath.split('/').length - 1];
    this.loadContractBasedOnTab(
      ['active', 'pending', 'finalized'].includes(currentTab)
        ? currentTab
        : 'active'
    );
  },
  data() {
    return {
      currentDescriptionText: '',
      descriptionModalShow: false,
      showHolidayModal: this.shouldShowHolidayModal(),
      teste_model: 'texto de teste!',
      teste_model_number: 3,
      teste_model_range: [9, 11],
      teste_model_date: '',
      teste_model_checkbox: true,
      teste_model_select: 4,
      teste_model_select_options: [1, 2, 3, 4, 5, 6],
      user_modal_show: false,
      recesso_2022: false,
      user_justification_modal_show: false,
      user_question_modal_show: false,
      client_cancel_contract_modal_show: false,
      contract_finalize_modal_show: false,
      justification_text: '',
      cancellation_reason: '',
      selected_vibbrante: {},
      selected_contract: {},
      finalized_modal_show: false,
      comments: [],
      vibbrante_name: '',
      alert_modal_show: false,
      alert_msg: '',
      balances_data: [],
      credit_transfer: {},
      value_contract_from: 0,
      value_contract_to: 0,
      hour_debit_contract_from: '',
      hour_credit_contract_to: 0,
      max_hour_credit_contract_to: 0,
      closedContractsPaginate: {
        totalPages: 0,
      },
      showAnnouncementModal: false,
      showingExportModal: false,
      selectedContractForExport: null,
      exportDateRange: {
        start: '',
        end: ''
      },
    };
  },
  methods: {
    shouldShowHolidayModal() {
      const today = new Date();
      return (
        today.getFullYear() === 2025 &&
        today.getMonth() === 1 && // Junho = 7
        today.getDate() >= 16 &&
        today.getDate() <= 20
      );
    },
    closeHolidayModal() {
      this.showHolidayModal = false;
      localStorage.setItem('holidayModalDismissed_2025_06', 'true');
    },
    showDescriptionModal(description) {
      this.currentDescriptionText = description;
      this.descriptionModalShow = true;
    },
    clickTabButton(tab) {
      setTimeout(() => this.loadContractBasedOnTab(tab), 1000);
    },
    showRecessoCampaing() {
      if (this.$route.query.campaing == 'recesso_2022') {
        this.recesso_2022 = true;
      }
    },
    getClientType() {
      return this.$store.state.auth.user.type;
    },
    showRatingModal(contract) {
      this.contract_finalize_modal_show = true;
      this.selected_contract = contract;
      this.vibbrante_name = contract.vibbrante.name;
    },
    getStatusDescription(status, release_reject_message) {
      if (status === 'waiting_confirmation_from_client') {
        return 'Aguardando assinatura do contratante';
      } else if (status === 'waiting_credit') {
        return 'Aguardando compra de créditos';
      } else if (status === 'reject_by_vibbrante' && release_reject_message) {
        return 'Profissional indisponível';
      } else if (status === 'reject_by_vibbrante' && !release_reject_message) {
        return 'Em revisão pela Vibbra';
      }
      return 'Aguardando assinatura do profissional';
    },
    openVibbranteNewTab(data) {
      const routeData = this.$router.resolve({
        // name: "client-search-vibbrante",
        path: '/client/search/vibbrante/' + data.slug,
      });
      window.open(routeData.href, '_blank');
    },
    searchVibbrantes() {
      this.$router.push({ name: 'client-search' });
    },
    openWallet() {
      this.$router.push({ name: 'client-wallet' });
    },
    showJustificationModal(contract, text, cancellation_reason) {
      this.selected_contract = contract;
      this.justification_text = text;
      this.cancellation_reason = cancellation_reason;
      this.user_justification_modal_show = true;
    },
    goToSign(contract) {
      if (contract.client.able_to_contract) {
        this.$router.push({
          name: 'client-sign',
          params: { id: contract.id, vibbrante_id: contract.vibbrante.id },
        });
      } else {
        this.alert_msg =
          'Para assinar contratos como pessoa jurídica, é necessário preencher TODOS os dados da sua empresa no seu perfil. Se preferir assinar como pessoa física, deve então preencher no seu perfil todos os seus dados pessoais.';
        this.alert_modal_show = true;
      }
    },
    loadContractBasedOnTab(tab) {
      try {
        const currentTab = tab == 'finalized' ? 'closed' : tab;
        const contractsStatusCapitalized =
          currentTab[0].toUpperCase() + currentTab.slice(1, currentTab.length);
        if (
          this.$store.getters[`vibbrante_${currentTab}_contracts`].length == 0
        )
          this[`load${contractsStatusCapitalized}Contracts`](1);
      } catch (error) {
        console.log('loadContractBasedOnTab error', error);
      }
    },
    loadPendingContracts() {
      clientApi
        .loadPendingContracts()
        .then(response => {
          if (response.status === 200) {
            this.$store.dispatch(
              'loadClientWaitingAnswerContracts',
              response.data
            );
            if (
              this.$route.query.openquestion === 'true' &&
              this.$route.query.contract_id !== undefined
            ) {
              let contract = null;
              response.data.forEach(element => {
                if (element.id === parseInt(this.$route.query.contract_id)) {
                  contract = element;
                }
              });
              this.showQuestion(contract);
            }
          }
        })
        .catch(e => {
          this.$notify(e, 'error');
        });
    },
    loadActiveContracts() {
      clientApi
        .loadActivesContracts()
        .then(response => {
          if (response.status === 200) {
            this.$store.dispatch('loadClientActivesContracts', response.data);
          }
        })
        .catch(e => {
          console.log('loadActiveContracts error >', e);
          this.$notify(e, 'error');
        });
    },
    onPaginationChange(currentPage) {
      this.closedContractsPaginate.currentPage = currentPage;
      this.loadClosedContracts(currentPage);
    },
    loadClosedContracts(currentPage) {
      try {
        this.$store.dispatch('loadClientClosedContracts', []);
        clientApi
          .loadClosedContracts(currentPage)
          .then(response => {
            if (response.status === 200) {
              this.closedContractsPaginate.totalPages =
                response.data.total_pages;
              this.$store.dispatch(
                'loadClientClosedContracts',
                response.data.contracts
              );
            }
          })
          .catch(e => {
            console.log('loadClosedContracts error', e);
            this.$notify(e, 'error');
          });
      } catch (error) {
        console.log('loadClosedContracts error', error);
      }
    },
    fetchData() {
      this.loadClientNotification();
      this.loadClientBalance();
    },
    loadClientNotification() {
      clientApi
        .clientNotifications()
        .then(response => {
          if (response.status === 200) {
            this.$store.dispatch('loadClientNotifications', response.data);
          }
        })
        .catch(e => {
          this.$notify(e, 'error');
        });
    },
    loadClientBalance() {
      clientApi
        .clientBalances()
        .then(response => {
          if (response.status === 200) {
            this.balances_data = response.data;
            this.$store.dispatch('loadClientBalance', response.data);
          }
        })
        .catch(e => {
          this.$notify(e, 'error');
        });
    },
    calcDiscount(hour_value, expected_hour_value) {
      return (100 * (expected_hour_value - hour_value)) / expected_hour_value;
    },
    showRejectModal(contract) {
      this.client_cancel_contract_modal_show = true;
      this.selected_contract = contract;
    },
    closeByReject(contract) {
      clientApi
        .clientCloseByReject(contract.id)
        .then(response => {
          if (response.status === 200) {
            clientApi
              .loadPendingContracts()
              .then(response => {
                if (response.status === 200) {
                  this.$store.dispatch(
                    'loadClientWaitingAnswerContracts',
                    response.data
                  );
                  this.hide();
                }
              })
              .catch(e => {
                this.$notify(e, 'error');
              });
          }
        })
        .catch(e => {
          this.$notify(e, 'error');
        });
    },
    goToTasks(name, contract_id) {
      this.$router.push({
        name: 'client-vibbrant',
        params: { id: contract_id, name },
      });
    },
    showQuestion(contract) {
      this.selected_contract = contract;
      clientApi
        .clientContractComment(contract.id)
        .then(response => {
          if (response.status === 200) {
            clientApi
              .clientContractCommentToRead(contract.id)
              .then(response => {
                clientApi.loadPendingContracts().then(response => {
                  if (response.status === 200) {
                    this.$store.dispatch(
                      'loadClientWaitingAnswerContracts',
                      response.data
                    );
                    this.hide();
                  }
                });
              });
            this.comments = response.data;
            this.user_question_modal_show = true;
          }
        })
        .catch(e => {
          this.$notify(e, 'error');
        });
    },
    searchWithFilter(vibbrante) {
      // let vibbrante = this.selected_contract.vibbrante
      this.$router.push({
        name: 'client-search',
        query: { profile: vibbrante.profile, focus: vibbrante.focus },
      });
    },
    showTabButton(tab) {
      if (tab === this.activeTab) {
        return 'active active nav-item nav-link';
      }
      return '';
    },
    showTabContent(tab) {
      if (tab === this.activeTab) {
        return 'show active';
      }
      return 'fade';
    },
    createCreditTransfer() {
      const constractFromId = this.formatContractId(
        this.credit_transfer.contract_from_id
      );
      const constractToId = this.formatContractId(
        this.credit_transfer.contract_to_id
      );

      if (constractFromId == constractToId) {
        this.$notify(
          'Contrato de origem e destino não podem ser o mesmo!',
          'error'
        );
      } else {
        clientApi
          .contractCreditTransfer({
            ...this.credit_transfer,
            client_id: this.$store.state.auth.user.id,
            contract_from_id: constractFromId,
            contract_to_id: constractToId,
            is_full_transfer: !!this.credit_transfer.is_full_transfer,
          })
          .then(response => {
            if (response.status === 200) {
              this.$notify('Transferência de crédito solicitada!', 'success');
              this.credit_transfer = {};
              this.value_contract_from = 0;
              this.value_contract_to = 0;
              this.hour_debit_contract_from = '';
              this.hour_credit_contract_to = '';
            }
          })
          .catch(e => {
            this.$notify(e, 'error');
          });
      }
    },
    disableButtonCreditTransfer() {
      if (
        !this.credit_transfer.contract_from_id ||
        !this.credit_transfer.contract_to_id ||
        this.credit_transfer.value_transfer <= 0 ||
        this.credit_transfer.value_transfer >
          this.credit_transfer.value_available
      ) {
        return true;
      }

      return false;
    },
    addAllValueToCreditTransfer() {
      this.$nextTick(() => {
        this.credit_transfer.value_transfer = this.credit_transfer
          .is_full_transfer
          ? this.credit_transfer.value_available
          : 0;
        if (this.credit_transfer.value_transfer > 0) {
          this.hour_debit_contract_from = Math.round(
            this.credit_transfer.value_transfer / this.value_contract_from
          );
          this.hour_credit_contract_to = Math.round(
            this.credit_transfer.value_transfer / this.value_contract_to
          );
          this.credit_transfer.value_transfer =
            this.value_contract_to * this.hour_credit_contract_to;
          if (
            this.credit_transfer.value_transfer >
            credit_transfer.value_available
          ) {
            this.hour_credit_contract_to = this.hour_credit_contract_to - 1;
            this.credit_transfer.value_transfer =
              this.value_contract_to * this.hour_credit_contract_to;
          }
        }
      });
    },
    changeValueTransfer() {
      this.$nextTick(() => {
        if (this.hour_credit_contract_to > 0) {
          this.credit_transfer.value_transfer =
            this.value_contract_to * this.hour_credit_contract_to;
          while (
            this.credit_transfer.value_transfer >
            this.credit_transfer.value_available
          ) {
            this.hour_credit_contract_to = this.hour_credit_contract_to - 1;
            this.credit_transfer.value_transfer =
              this.value_contract_to * this.hour_credit_contract_to;
          }
          this.hour_debit_contract_from = Math.round(
            this.credit_transfer.value_transfer / this.value_contract_from
          );
        } else {
          this.credit_transfer.value_transfer = 0;
          this.hour_debit_contract_from = 0;
        }
      });
    },
    formatContractId(contract) {
      return Number(contract.split('-')[0].trim());
    },
    setContractFrom() {
      this.$nextTick(() => {
        const contractId = this.formatContractId(
          this.credit_transfer.contract_from_id
        );
        const currentBalance = this.balances_data.details.find(
          balance => balance.contract_id === contractId
        );
        this.credit_transfer.value_available = Number(
          currentBalance.credit
        ).toFixed(2);

        this.hour_credit_contract_from = 0;
        this.hour_credit_contract_to = 0;
        this.credit_transfer.value_transfer = 0;
        this.credit_transfer.contract_to_id = null;

        const contract = this.activesContracts.find(
          contract => contract.id === contractId
        );
        this.value_contract_from = contract
          ? Number(contract.hour_value).toFixed(2)
          : 0;
      });
    },
    setContractTo() {
      this.$nextTick(() => {
        const contractId = this.formatContractId(
          this.credit_transfer.contract_to_id
        );

        this.hour_credit_contract_from = 0;
        this.hour_credit_contract_to = 0;
        this.max_hour_credit_contract_to = 0;
        this.credit_transfer.value_transfer = 0;

        let contract = this.pendingContracts.find(
          contract => contract.id === contractId
        );
        if (!contract) {
          contract = this.activesContracts.find(
            contract => contract.id === contractId
          );
        }
        console.log('contract', contract);
        console.log('contract.hour_value', contract.hour_value);
        this.value_contract_to = contract
          ? Number(contract.hour_value).toFixed(2)
          : 0;
        this.max_hour_credit_contract_to = Math.round(
          this.credit_transfer.value_available / this.value_contract_to
        );
      });
    },
    hideAnnouncementModal() {
      this.showAnnouncementModal = false;
    },
    showExportModal(contract) {
      this.selectedContractForExport = contract;
      this.showingExportModal = true;
    },
    closeExportModal() {
      this.showingExportModal = false;
      this.selectedContractForExport = null;
      this.exportDateRange = {
        start: '',
        end: ''
      };
    },
    async exportToExcel() {
      if (!this.selectedContractForExport) return;

      try {
        // Fetch tasks for the selected date range
        const response = await clientApi.getTasks(
          this.selectedContractForExport.id,
          this.exportDateRange.start,
          this.exportDateRange.end
        );

        const tasks = response.data.map(task => ({
          'Data': new Date(task.task_date).toLocaleDateString(),
          'Título': task.description,
          'Horas Trabalhadas': task.duration
        }));

        // Create workbook and worksheet
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(tasks);

        // Add worksheet to workbook
        XLSX.utils.book_append_sheet(wb, ws, 'Horas Trabalhadas');

        // Generate filename with date range
        const fileName = `horas_trabalhadas_${this.exportDateRange.start}_${this.exportDateRange.end}.xlsx`;

        // Save file
        XLSX.writeFile(wb, fileName);
        this.closeExportModal();
      } catch (error) {
        console.error('Erro ao exportar dados:', error);
      }
    },
  },
  watch: {
    $route: function(newVal) {
      try {
        const fullPath = newVal.fullPath;
        const currentTab = fullPath.split('/')[fullPath.split('/').length - 1];
        this.loadContractBasedOnTab(currentTab);
      } catch (error) {
        console.log('watch route error', error);
      }
    },
  },
  computed: {
    user() {
      console.log({user1: this.$store.getters.user})
      return this.$store.getters.user;
    },
    pendingContracts() {
      return this.$store.getters.client_pending_contracts;
    },
    activesContracts() {
      return this.$store.getters.client_actives_contracts;
    },
    closedContracts() {
      return this.$store.getters.client_closed_contracts;
    },
    rejectModalTitle() {
      if (this.selected_contract.vibbrante == undefined) {
        return 'Cancelar contrato';
      }

      return 'Cancelar contrato - ' + this.selected_contract.vibbrante.name;
    },
    activesContractsIds() {
      const contractsIds = [];

      this.activesContracts.forEach(element => {
        contractsIds.push(`${element.id} - ${element.vibbrante.name}`);
      });

      return contractsIds;
    },
    pendingContractsIds() {
      const contractsIds = [];
      const contractId = this.credit_transfer.contract_from_id
        ? this.formatContractId(this.credit_transfer.contract_from_id)
        : 0;

      this.pendingContracts.forEach(element => {
        if (element.status === 'waiting_credit' && contractId != element.id)
          contractsIds.push(`${element.id} - ${element.vibbrante.name}`);
      });

      this.activesContracts.forEach(element => {
        if (contractId != element.id)
          contractsIds.push(`${element.id} - ${element.vibbrante.name}`);
      });

      return contractsIds;
    },
  },
};
</script>

<style lang="scss">
.user-item > .divider {
  display: none;
}
.user-item > .user-item-avatar {
  margin: 0;
}
.avatar {
  position: relative;
  .avatar-remove {
    position: absolute;
    top: 0;
    right: 0;
    line-height: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    background: rgba(0, 0, 0, 0.5);
    color: white;
    border-radius: 50%;
    font-size: 20px;
    font-family: sans-serif;
  }
}
.user-profile {
  div {
    font-size: 14px;
  }
}
.text-header {
  font-weight: 700;
  margin: 8px 0;
}

.text-description {
  color: #2196f3 !important;
  cursor: pointer;
  text-decoration: underline;
}
.text-description {
   overflow: hidden;
   position: relative;
   background: white;   //or other color
}

.text-description:after {
  content: '...';       //the ellipsis
  position: absolute;   //positioned in bottom-right
  bottom: 0;            //...
  right: 0;             //...
  padding: 0 0.3em;     //give some separation from text
  background: inherit;  //same color as container
}

.text-description span:after {
  content: '\0000a0';   //a space
  position: absolute;   //to cover up ellipsis if needed
  width: 1000px;        //...
  z-index: 1;           //...
  background: white;    //must match container's color.  can't use inherit here.
}
</style>



// WEBPACK FOOTER //
// src/parts/pages/client/vibbrants/vibbrants.vue